import {
  useExecutiveReport,
  useGlobalCurrency,
  useReportBespoke,
  useSnapshot,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import SimpleTable from "src/components/SimpleTable/SimpleTable";
import s from "./PositionsWidget.module.scss";

import { usePositionsWidget } from "./hooks/usePositionsWidget";
import { observer } from "mobx-react-lite";
import { IntervalPaginator } from "../IntervalPaginator/IntervalPaginator";
import { useState } from "react";

export const PositionsWidget = observer(
  ({ periodContext, cellId, pageId, width }: ReportWidgetProps) => {
    const { portfolioId } = useParams();
    const [startIndex, setStartIndex] = useState(0);
    const MAX_POSITIONS = 40; // Changed from 10 to 20 to double the amount of positions shown
    const { data } = useSnapshot(portfolioId, periodContext.periodForRequest);
    const { columns: overrideColumns } = usePositionsWidget(cellId, pageId);
    const { generating } = useReportBespoke();
    const tableData = data?.data || [];
    // Sort tableData by percentOfPortfolio in descending order and limit to MAX_POSITIONS
    const sortedTableData = [...tableData].sort(
      (a, b) => (b.percentOfPortfolio || 0) - (a.percentOfPortfolio || 0)
    );
    const paginatedData = sortedTableData.slice(
      startIndex,
      startIndex + MAX_POSITIONS
    );

    return (
      <div style={{ width }} className={s.positionsWidget}>
        {!generating && (
          <IntervalPaginator
            totalItems={sortedTableData.length}
            currentStart={startIndex}
            maxInterval={MAX_POSITIONS}
            onIntervalChange={setStartIndex}
          />
        )}
        <SimpleTable
          data={paginatedData}
          columns={overrideColumns}
          sortable={false}
          reorderable={false}
        />
      </div>
    );
  }
);
